<template>
  <mdb-carousel :interval="8000">
    <mdb-carousel-item img :src="firstslide" alt="First slide" />
    <mdb-carousel-item img :src="secondslide" alt="Second slide" />
    <mdb-carousel-item img :src="thirdslide" alt="Third slide" />
  </mdb-carousel>
</template>
<script>
  import { mdbCarousel, mdbCarouselItem } from 'mdbvue';
  export default {
    name: 'carousel',
    components: {
      mdbCarousel,
      mdbCarouselItem
    },
    props: {
      firstslide: String,
      secondslide: String,
      thirdslide: String
    }
  }
</script>